module.exports = __webpack_public_path__ + "img/rightUp.2e84169a.png";